import styled from "styled-components";

export const IconOptionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconContainer = styled.div`
  height: 16px;
  width: 16px;
  color: ${({ theme }) => theme.colors.default[400]};

  svg {
    width: 100%;
    height: 100%;
  }
`;
